"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DetailHeights;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var defaultState = _immutable.default.Map({});

function DetailHeights() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      file = action.file,
      height = action.height;

  switch (type) {
    case _ActionTypes.UPDATE_DETAIL_HEIGHT:
      return state.set(file.get('id'), height);

    default:
      return state;
  }
}

module.exports = exports.default;